<template>
    <div class='container-fluid suspect content-type-36' :class="[cssClass]">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <button :class="['btn-s-icon', 'suspect-previous', !isFirstCompany ? 'btn-5' : 'btn-disabled']" :disabled="isFirstCompany" @click="loadPreviousCompany" v-if="showActions" v-tooltip:top="'tooltips.prospect_back'">
                            <div class="icon-chevrons-pos"></div>
                        </button>
                        <button class="btn-7 btn-m-icon suspect-qualify" @click="qualify(1)" v-if="showActions" v-tooltip:top="'tooltips.qualify'">
                            <div class="icon-check-neg"></div>
                        </button>
                        <button class="btn-1 btn-m-icon close-company" @click="close()" v-if="showActions && !hasMediumScreen">
                            <div class="icon-signout-neg"></div>
                        </button>
                        <button class="btn-6 btn-m-icon suspect-disqualify" @click="qualify(0)" v-if="showActions" v-tooltip:top="'tooltips.disqualify'">
                            <div class="icon-close-neg"></div>
                        </button>
                        <button :class="['btn-s-icon', 'suspect-skip', !isLastCompany || mode === 'new' ? 'btn-5' : 'btn-disabled']" :disabled="isLastCompany && mode !== 'new'" @click="qualify(-1)" v-if="showActions" v-tooltip:top="'tooltips.prospect_skip'">
                            <div class="icon-chevrons-pos"></div>
                        </button>
                        <div class="loading-spinner suspect-settings" v-if="loading">
                            <div class="loading-spinner-type-2"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'pinia';
    import { useProspectStore } from '@/stores/prospect';
    import { useCompaniesStore } from '@/stores/companies';
    import { useScreenWidthStore } from '@/stores/utils/screenWidth';

    export default {
        name: "CompanyActions",
        props: {
            cssClass: {
                type: String,
                required: false
            }
        },
        data() {
            return {
                qualifyingCompany: false
            }
        },
        computed: {
            ...mapState(useProspectStore, ['prospect']),
            ...mapState(useScreenWidthStore, ['hasMediumScreen']),
            ...mapState(useCompaniesStore, ['mode', 'error', 'isFirstCompany', 'isLastCompany']),
            ...mapState(useCompaniesStore, { loadingCompanies: 'loading'}),
            showActions() {
                return !this.loading && !this.error && this.prospect;
            },
            loading() {
                return this.loadingCompanies || this.qualifyingCompany;
            }
        },
        methods: {
            ...mapActions(useCompaniesStore, ['routeToMode', 'closeCompany', 'loadNextCompany', 'loadPreviousCompany', 'qualifyCompany', 'loadNextCompany']),
            async qualify(label) {
                this.qualifyingCompany = true;
                await this.qualifyCompany(label);

                if(this.isLastCompany && this.mode !== 'new') {
                    this.closeCompany();
                } else {
                    this.loadNextCompany();
                }
                this.qualifyingCompany = false;
            },
            close() {
                if(this.mode === 'new') {
                    this.routeToMode('all');
                } else {
                    this.closeCompany();
                }
            }
        }
    }
</script>